// src/pages/admin/AdminCertificates.jsx
import React, { useState, useEffect } from 'react';
import {  CheckBadgeIcon } from '@heroicons/react/24/outline';
import adminApi from '../../api/adminApi';

const AdminCertificates = () => {
  const [certs, setCerts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // I recommend creating this endpoint in your adminController
    const fetchCerts = async () => {
      try {
        const response = await adminApi.getCertificateLedger(); 
        setCerts(response);
      } catch (error) {
        console.error("Failed to fetch certs");
      } finally {
        setLoading(false);
      }
    };
    fetchCerts();
  }, []);

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-br from-red-900/20 to-gray-800 border border-red-500/20 rounded-2xl p-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-white flex items-center">
              <CheckBadgeIcon className="h-8 w-8 mr-3 text-red-500" />
              Official Certificate Ledger
            </h1>
            <p className="text-gray-400 mt-2">Manage and verify all academic and participation credentials.</p>
          </div>
        </div>
      </div>

      <div className="bg-gray-800/50 border border-gray-700 rounded-2xl overflow-hidden">
        <table className="w-full text-left border-collapse">
          <thead className="bg-gray-900/50 text-gray-400 text-xs uppercase tracking-widest">
            <tr>
              <th className="px-6 py-4 font-semibold">Recipient</th>
              <th className="px-6 py-4 font-semibold">Type</th>
              <th className="px-6 py-4 font-semibold">Serial Number</th>
              <th className="px-6 py-4 font-semibold text-right">Verification</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-700">
            {certs.map((cert) => (
              <tr key={cert.id} className="hover:bg-gray-700/30 transition-all">
                <td className="px-6 py-4 text-white font-medium">{cert.user_name}</td>
                <td className="px-6 py-4">
                  <span className={`px-3 py-1 rounded-full text-[10px] font-bold border ${
                    cert.certificate_type === 'INTERNSHIP' ? 'bg-green-500/10 text-green-400 border-green-500/20' :
                    cert.certificate_type === 'WINNER' ? 'bg-yellow-500/10 text-yellow-400 border-yellow-500/20' :
                    'bg-blue-500/10 text-blue-400 border-blue-500/20'
                  }`}>
                    {cert.certificate_type}
                  </span>
                </td>
                <td className="px-6 py-4 font-mono text-sm text-gray-400">{cert.certificate_serial}</td>
                <td className="px-6 py-4 text-right">
                  <button
                 onClick={() => window.open(`/verify-certificate/${cert.certificate_serial}`, '_blank')}
                  className="text-red-400 hover:text-red-300 text-xs font-bold uppercase tracking-tighter underline">
                    Public View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminCertificates;